import { MentionBadge } from '@/components/MentionBadge'
import type { ResponseMetaProps } from './ResponseMeta.types'

// The at-a-glance verdict for one engine answer, shown in its collapsed row.
export function ResponseMeta({ response }: ResponseMetaProps) {
  return (
    <>
      <MentionBadge label={response.mention} mention={response.mention} />

      {response.position > 0 && (
        <span className="text-xs text-muted-foreground">
          pos {response.position}
        </span>
      )}

      {response.sentiment !== 'na' && (
        <span className="text-xs text-muted-foreground">
          {response.sentiment}
        </span>
      )}

      <span className="ml-auto text-xs text-muted-foreground">
        {response.score.toFixed(1)} pts
      </span>
    </>
  )
}
